import Decimal from 'decimal.js'

import {utilModule} from '../module.js';
import {CurrencyService} from '@nuskin/ns-shop';
import {RunConfigService, dateFormatter} from '@nuskin/ns-util';
import STATE_CONFIG from './state-config';

utilModule.filter('qtyFilter', function() {
    return function(input) {
        return input.split(':')[0];
    };
});

utilModule.filter('lastFourFilter', function() {
    return function(input) {
        let result = input;
        if(input) {
            result = input.slice(-4);
        }
        return result;
    };
});

utilModule.filter('thumbnailFilter', function() {
    return function(sku) {
        return RunConfigService.getBaseUrl() + '/content/products/' + sku.substring(0, 2) + '/' + sku.substring(2, 4)
        + '/' + sku.substring(4, 6) + '/' + sku + '/jcr:content/fullImage.img.100.100.png';
    };
});

utilModule.filter('thumbnailFilterSmall', function() {
    return function(sku) {
        return RunConfigService.getBaseUrl() + '/content/products/' + sku.substring(0, 2) + '/' + sku.substring(2, 4)
            + '/' + sku.substring(4, 6) + '/' + sku + '/jcr:content/fullImage.img.50.50.png';
    };
});

function formatCurrency(amount, country, language) {
    // note that currencyFormatter is pulled from the server
    let rv = '---------';
    if (typeof amount === 'number') {
        if (typeof(country) === 'undefined')
            rv = CurrencyService.format(amount);
        else {
            if (typeof(language) === 'undefined')
                rv = CurrencyService.format(amount, country);
            else
                rv = CurrencyService.format(amount, country, language);
        }
    } else if (amount && amount.length > 0) {
        rv = amount;
    }

    return rv;
}

utilModule.filter('toCents', function() {
    return function(amount) {
        return parseInt(amount * 100);
    }
});

utilModule.filter('currencyFilter', function() {
    return function(amount, country, language) {
        if (typeof amount === 'string') {
            amount = parseFloat(amount);
        }
        if (typeof(country) === 'undefined')
            return formatCurrency(amount);
        else {
            if (typeof(language) === 'undefined') {
                return formatCurrency(amount, country);
            }
            return formatCurrency(amount, country, language);
        }
    };
});

utilModule.filter('replaceCurrencyFilter', function() {
    return function(string, amount) {
        return string.replace('{0}', formatCurrency(amount));
    };
});

utilModule.filter('psvFilter', function() {
    return function(psv) {
        // this will make an integer (say 5) to become 5.00
        let rv = '---------';
        psv = psv || 0;
        if (typeof psv === 'number') {
            rv = parseFloat(Math.round(psv *100) / 100).toFixed(2) + ' PSV';
        }

        return rv;
    };
});

utilModule.filter('truncatedCurrencyFilter', function() {
    return function(amount, cntry, lang) {
        amount = parseFloat(amount);

        if (!cntry) {
            return formatCurrency(amount);
        } else {
            const currency = CurrencyService.getCurrency(cntry);
            // Decimal fixes the rounding of 9.20 so it won't round to 9.19.
            const decimalNumber = new Decimal(amount);
            const precision = parseInt(currency.accuracy);
            const roundedAmount = decimalNumber.toDecimalPlaces(precision).toNumber();
            return lang ? formatCurrency(roundedAmount, cntry, lang) : formatCurrency(roundedAmount, cntry);
        }
    };
});

utilModule.filter('decimalPlaceFilter', function() {
    return function(number, decimals) {
        let rv = '---------';
        number = number || 0;
        if (typeof number === 'number') {
            rv = parseFloat(Math.round(number * 100) / 100).toFixed(decimals);
        }
        return rv;
    };
});

utilModule.filter('csvFilter', function() {
    return function(csv) {
        // this will make an integer (say 5) to become 5.00
        let rv = '---------';
        if (typeof csv === 'number') {
            rv = parseFloat(Math.round(csv *100) / 100).toFixed(2) + ' CSV';
        }

        return rv;
    };
});

utilModule.filter('expirationFilter', ['nsUtil', function(nsUtil) {
    return function(expMonth, expYear, expLabel, expiredText) {
        let exp = "Exp: ";

        if (expLabel) {
            exp = expLabel + " ";
        }

        if (nsUtil.isExpiredNow(expMonth, expYear)) {
            let expired = "EXPIRED";
            if (expiredText) {
                expired = expiredText;
            }
            return exp + expMonth + '/' + expYear + " <span class=\"error\" style=\"color: red;\">" + expired + "</span>";
        } else {
            return exp + expMonth + '/' + expYear;
        }
    };
}]);

utilModule.filter('dateFilter', function() {
    return function(milliseconds) {
        return new Date(milliseconds).toDateString();
    };
});

utilModule.filter('simpleDate', function() {
    return function(milliseconds) {
        return dateFormatter.simpleDate(milliseconds);
    };
});

utilModule.filter('monthDayYearFormattedDate', function() {
    return function(milliseconds) {
        return dateFormatter.getMonthDayYearFormattedDate(milliseconds);
    };
});

utilModule.filter('militaryFormattedDate', function() {
    return function(data) {
        return dateFormatter.getMilitaryFormattedDate(data.date, data.locale);
    };
});

utilModule.filter('countryFormattedDate', function() {
    return function(data) {
        return dateFormatter.getCountryFormattedDate(data.date, data.locale);
    };
});

utilModule.filter('deliveryTimeFilter', function() {
    return function(milliseconds,duration) {
        let date = new Date(milliseconds);
        return (date.getMonth()+1) + "/" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + " - " + (date.getHours()+duration) + ":" + date.getMinutes();
    };
});

utilModule.filter("sanitize", ['$sce', function($sce) {
    return function(htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
}]);

utilModule.filter('hideLeadingZero', function() {
    return function(orderNumber, isHiding) {
        let rv = orderNumber;
        if (rv) {
            if (isHiding) {
                if (rv.charAt(0) === '0') {
                    rv = rv.slice(1);
                }
            }
        }
        return rv;
    };
});

utilModule.filter('stripHtml', function() {
    return function(text) {
        return String(text).replace(/<[^>]+>/gm, '');
    }
});


// In Japan we get a number instead of the state.  This will replace the number with the state name
utilModule.filter('stateName', function() {
    return function (stateValue) {
        let runConfig = RunConfigService.getRunConfig(),
            stateValueName = stateValue;
        if (STATE_CONFIG[runConfig.country]) {
            STATE_CONFIG[runConfig.country].stateList.forEach((state) => {
                if (state.key === stateValue) {
                    stateValueName = state.value;
                }
            });
        }
        return stateValueName;
    };
});
